import {
  BarChartOutlined,
  FieldTimeOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  HomeOutlined,
  LockOutlined,
  RollbackOutlined,
  SyncOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { ItemType } from "antd/es/menu/interface";
import { Link } from "react-router-dom";

export const baseMenuItems: ItemType[] = [
  {
    key: "1",
    icon: <HomeOutlined />,
    label: <Link to="/">Inicio</Link>,
  },
  //key 2 en menuAdmin
  {
    key: "3",
    icon: <BarChartOutlined />,
    label: <Link to="/consulta-stock">Consulta de stock</Link>,
  },
  {
    key: "5",
    icon: <FolderOpenOutlined />,
    label: "Gestión",
    children: [
      {
        key: "5.1",
        icon: <UnlockOutlined />,
        label: <Link to="/aperturas-caja">Aperturas de caja</Link>,
      },
      {
        key: "5.2",
        icon: <LockOutlined />,
        label: <Link to="/cierres-caja">Cierres de caja</Link>,
      },
      // Va con las otras dos de caja, y no al final, porque la pregunta que
      // responde --cuánto llevo-- se hace entre abrir y cerrar.
      {
        key: "5.6",
        icon: <FieldTimeOutlined />,
        label: <Link to="/como-va-el-turno">Cómo va el turno</Link>,
      },
      {
        key: "5.3",
        icon: <FileTextOutlined />,
        label: <Link to="/facturas">Facturas</Link>,
      },
      {
        key: "5.4",
        icon: <RollbackOutlined />,
        label: <Link to="/abonos">Abonos</Link>,
      },
      {
        key: "5.5",
        icon: <SyncOutlined />,
        label: <Link to="/facturas-pendientes">Pendientes de sincronizar</Link>,
      },
    ],
  },
  {
    key: "6",
    icon: <FileDoneOutlined />,
    label: <Link to="/informes">Informes</Link>,
  },
];
